import React from "react";
import CustomModal from "../../../../components/Modal/CustomModal";
import CustomTabContainer from "../../../../components/CustomTabContainer";
import CustomTab from "../../../../components/CustomTab";
import { AssignIcon } from "../../../../components/buttons/IconButtons";
import LayoutsModalApp from "../Functionality/LayoutsModalApp";
import { LAYOUTS_MODAL_TAB } from "../Model/Model";
import CreateLayoutTab from "./CreateLayoutTab";
import SavedLayoutsTab from "./SavedLayoutsTab";

/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    Full Stack
 * @Email       kpozos@ibl.mx
 *
 * Layouts modal: creates a layout from a predefined structure or manages the saved ones.
 */
const LayoutsModal = ({
    show,
    onHide,
    activeTab,
    setActiveTab,
    activeLayoutId,
    savedLayoutsModified,
    setSavedLayoutsModified,
    display,
    onCreate,
    onOpen,
    onRename,
    onDelete,
    canCreate = false,
    canUpdate = false,
    canDelete = false
}) => {
    const {
        t,
        item,
        emptyFields,
        handleChange,
        handleSelectType,
        handleConfirm
    } = LayoutsModalApp({ onCreate });

    return (
        <CustomModal
            show={show}
            onHide={onHide}
            size='lg'
            display={display}
            cancelButton={activeTab === LAYOUTS_MODAL_TAB.CREATE.ID}
            confirmButton={activeTab === LAYOUTS_MODAL_TAB.CREATE.ID}
            onConfirm={handleConfirm}
            topLeftHeader={
                <div className='d-flex align-items-center gap-2 pb-2'>
                    <AssignIcon className='btn-icon-svg-32px icon-color-text-950' />
                    <p className='fs-24px ibl-font-w-600 font-color-text-950'>{t('layouts')}</p>
                </div>
            }
            classNameBody='pt-0'
        >
            <div className='border-full-shades-300 border-radius-8px'>
                <CustomTabContainer
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    className='rounded-top border-0 p-2'
                    classNameTabs='flex-grow-0'
                >
                    {/* The create tab is only shown to the admins that can create layouts */}
                    {Object.values(LAYOUTS_MODAL_TAB).filter((tab) => canCreate || tab.ID !== LAYOUTS_MODAL_TAB.CREATE.ID).map((tab) => (
                        <CustomTab
                            key={tab.ID}
                            id={`tab_lm_${tab.ID}`}
                            title={t(tab.TRANS)}
                            icon={<tab.ICON className='btn-icon-svg-20px' />}
                            selected={activeTab === tab.ID}
                            onClick={() => setActiveTab(tab.ID)}
                        />
                    ))}
                </CustomTabContainer>
                <div className='border-bottom-shades-300' />

                <div className='p-3'>
                    {activeTab === LAYOUTS_MODAL_TAB.CREATE.ID
                        ? <CreateLayoutTab
                            item={item}
                            emptyFields={emptyFields}
                            handleChange={handleChange}
                            onSelectType={handleSelectType}
                        />
                        : <SavedLayoutsTab
                            activeLayoutId={activeLayoutId}
                            modified={savedLayoutsModified}
                            setModified={setSavedLayoutsModified}
                            onOpen={onOpen}
                            onRename={onRename}
                            onDelete={onDelete}
                            canUpdate={canUpdate}
                            canDelete={canDelete}
                        />
                    }
                </div>
            </div>
        </CustomModal>
    );
};

export default LayoutsModal;
